import { SiteListingFilterProps } from "pages/Site/pages/type";
import React, { useState } from "react";
import { Button, Select, TextField } from "shared";
import { SelectItem } from "shared/components/Input/type";
import ModalFilter from "./ModalFilter";
import utils from "resources/utils";
import { useEffect } from "react";
import t from "utils/Lang";

const SiteListingFilter = ({
  dataCities,
  dataStatus,
  dataUser,
  onFilter,
  onApply,
  onCreateSite,
  normalize,
  currentStatus,
  tableMapping,
}: SiteListingFilterProps) => {
  const [modal, setModal] = useState(false);
  const [internalCode, setInternalCode] = useState("");
  const debounceInternalCode = utils.useDebounce(internalCode, 300);

  const toggle = () => setModal(!modal);
  const SeparateItem = () => <div style={{ width: 10 }} />;
  const onSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFilter("search", event.target.value);
  };
  const onInternalCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInternalCode(event.target.value);
  };

  const status = dataStatus.find((s) => s.value == currentStatus);
  const onSelect =
    (type: "status" | "city" | "user") => (data: Array<SelectItem>) => {
      onFilter(type, data);
    };
  useEffect(() => {
    onFilter("internal_code", debounceInternalCode);
  }, [debounceInternalCode]);
  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div
        style={{
          flex: 1,
          flexWrap: "wrap",
          display: "flex",
          alignItems: "center",
        }}
      >
        <TextField
          style={styles.mt10}
          type="outline"
          placeholder={t().site_listing__search_name_placeholder}
          icon="search"
          onChange={onSearch}
        />
        <SeparateItem />
        <Select
          label={t().site_listing__status}
          data={dataStatus}
          style={styles.mt10}
          onChanged={onSelect("status")}
          editable
          values={(status && [status]) || []}
        />
        <SeparateItem />
        <TextField
          style={styles.mt10}
          type="outline"
          placeholder="Internal code..."
          onChange={onInternalCodeChange}
        />
        {!normalize && (
          <>
            <SeparateItem />
            <Select
              label={t().site_listing__city}
              data={dataCities}
              style={styles.mt10}
              onChanged={onSelect("city")}
              isMultiple
            />
            <SeparateItem />
            <Select
              label={t().site_listing__assignee}
              data={dataUser}
              style={styles.mt10}
              onChanged={onSelect("user")}
              editable
            />
            <SeparateItem />
            <Button
              onClick={toggle}
              label={t().site_listing__select_column_to_display}
              icon="view_column"
              size="small"
              style={styles.mt10}
            />
          </>
        )}
      </div>
      <div style={styles.mt10}>
        <Button
          label={t().site_listing__create_new_site}
          icon="add"
          type="primary"
          size="small"
          onClick={onCreateSite}
        />
      </div>
      <ModalFilter
        tableMapping={tableMapping}
        onApply={onApply}
        toggle={toggle}
        isOpen={modal}
      />
    </div>
  );
};

const styles = {
  mt10: { marginTop: 10 },
};

export default SiteListingFilter;
